/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 4/17/20
 * Time: 3:14 PM
 */
/*global google*/

import React from 'react';
import MapProperties from './DireactionProperties'
import './GoogleDirectionMap.scss';
import {InfoWindow} from "react-google-maps";
import markerIcon from "../../../assets/icon/marker2.png";
const {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
} = require("react-google-maps");

const {compose, withProps, withHandlers, lifecycle} = require("recompose");
const MapWithAMarkerClusterer = compose(
    withProps({

        containerElement: <div className={"containerElement"} style={{height: `335px`}}/>,
        mapElement: <div className={"mapElement"} style={{height: `100%`}}/>
    }),
    withHandlers({}),
    withGoogleMap,
    lifecycle({
        componentDidMount() {
        }
    })
)(props => {

        return (

            <GoogleMap
                defaultZoom={10}
                defaultCenter={{
                    lat: props.markers ? props.markers.latitude : 7.1832093,
                    lng: props.markers ? props.markers.longitude : 79.8956875
                }}
                defaultOptions={{
                    scrollwheel: true,
                    zoomControl: false,
                    draggable: true,
                    disableDefaultUI: true,
                    styles: MapProperties
                }}
                onDrag={props.onDrag}
                ref={props.onMapMounted}
            >
                {props.markers !== null ?
                    <Marker
                        icon={{
                            url: markerIcon
                        }}
                        title={props.markers.address}
                        onClick={props.onClick}
                        position={{lat: props.markers.latitude, lng: props.markers.longitude}}
                    >
                        {
                            -1 === props.user ?
                                <InfoWindow onCloseClick={() => props.setUser()}>
                                    <div>
                                        <center>
                                            <label style={{
                                                color: '#8d0c1e',
                                                fontWeight: '600'
                                            }}>{props.markers.address}</label>

                                        </center>
                                    </div>
                                </InfoWindow> : null
                        }
                    </Marker>
                    : null
                }
            </GoogleMap>
        )
    }
);

class App extends React.PureComponent {
    state = {
        user: 0
    };
    markerClick = () => {
        this.setState({
            user: -1
        });
    };
    onMapMounted = ref => {
        refs.map = ref;
    };
    onDrag = () => {
        let {markers} = this.props;
        if (markers) {
            const obj = {
                latitude: refs.map.getCenter().lat(),
                longitude: refs.map.getCenter().lng(),
                address: markers.address
            };
            this.props.updateMapLocation(obj);
        }
    };

    render() {
        let {markers} = this.props;
        return (
            <div>
                <MapWithAMarkerClusterer
                    onDrag={this.onDrag}
                    onMapMounted={this.onMapMounted}
                    user={this.state.user}
                    onClick={this.markerClick}
                    markers={markers}
                    setUser={() => this.setState({user: 0})}
                />
            </div>
        );
    }
}
const refs = {
    map: undefined
};

export default App;
